import { render } from "./LiveVideo.vue?vue&type=template&id=490bbdff&scoped=true"
import script from "./LiveVideo.vue?vue&type=script&lang=js"
export * from "./LiveVideo.vue?vue&type=script&lang=js"

import "./LiveVideo.vue?vue&type=style&index=0&id=490bbdff&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490bbdff"]])

export default __exports__